
import { PubSub } from '@/PubSubClass';
import MqttMixIn from '@/mixins/mqttManagement';
import GlobalStore from '@/store/modules/global';
import MachineStore from '@/store/modules/machine';
import { MqttMessage } from '@/flightpath-components/models/mqttPayload/GPSUpdateMessage';
import { Component, Mixins, Vue } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';

@Component
export default class MachineEngineInfo extends Mixins(MqttMixIn) {
  machineStore = getModule(MachineStore, this.$store);
  formatDecimal = new Intl.NumberFormat(navigator.language.split('-')[0] || 'en', { style: 'decimal', maximumFractionDigits: 2 });
  formatInt = new Intl.NumberFormat(navigator.language.split('-')[0] || 'en', { style: 'decimal', maximumFractionDigits: 0 });
  globalStore = getModule(GlobalStore, this.$store);

  created(): void {
    this.addMqttVisibility(this.globalStore.machineMarkerTopic, () =>
      PubSub.subscribe(this.globalStore.machineMarkerTopic).subscribe({
        next: (data: MqttMessage) => {
          if (data.value.Key.machineId === this.machineStore.selectedMachineMarker?.Key.machineId) {
            this.machineStore.setSelectedMachineMarker(data.value);
          }
        },
        error: (error) => this.mqttError(error)
      })
    );
    this.actions.forEach((act, key) => {
      this.subscriptions.set(key, act());
    });
  }

  destroyed() {
    this.removeMqttVisibility();
  }
}
